import { Box, Flex, Group, SimpleGrid, Skeleton, Stack } from "@mantine/core";
import {
  EXPO_HEAD_SIDEBAR_BG,
  FACILITATOR_SIDEBAR_WIDTH_EXPANDED_PX,
  SIDEBAR_GRIDLINE_OVERLAY,
} from "@/components/layout/sidebarLayout.const";

const HEADER_HEIGHT = 64;
const SIDEBAR_WIDTH = FACILITATOR_SIDEBAR_WIDTH_EXPANDED_PX;

/** Dashboard-shaped content wait — not the company Discover card grid. */
export function ExpoHeadContentFallback() {
  return (
    <Box p="md">
      <Skeleton height={28} width={240} mb={8} />
      <Skeleton height={14} width={180} mb="lg" />
      <SimpleGrid cols={{ base: 2, sm: 3, md: 5 }} spacing="md" mb="lg">
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={`expo-head-stat-${i}`} height={84} radius="md" />
        ))}
      </SimpleGrid>
      <Skeleton height={18} width={200} mb="sm" />
      <SimpleGrid cols={{ base: 1, md: 3 }} spacing="md">
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton key={`expo-head-chart-${i}`} height={220} radius="md" />
        ))}
      </SimpleGrid>
    </Box>
  );
}

/** Full-page wait matching ExpoHeadLayout chrome (teal rail + header), not company Discover. */
export function ExpoHeadAppShellSkeleton() {
  return (
    <Flex direction="column" style={{ minHeight: "100dvh", background: "#ffffff" }}>
      <Group
        h={HEADER_HEIGHT}
        wrap="nowrap"
        gap={0}
        bg="white"
        style={{ borderBottom: "1px solid #E5E7EB", flexShrink: 0 }}
      >
        <Group
          gap={8}
          wrap="nowrap"
          px="xs"
          h="100%"
          visibleFrom="sm"
          style={{
            width: SIDEBAR_WIDTH,
            flexShrink: 0,
            backgroundColor: EXPO_HEAD_SIDEBAR_BG,
            backgroundImage: SIDEBAR_GRIDLINE_OVERLAY,
            borderRight: "1px solid rgba(255, 255, 255, 0.14)",
          }}
        >
          <Skeleton height={28} width={96} radius="sm" style={{ opacity: 0.55 }} />
          <Skeleton height={20} width={44} radius="xl" style={{ opacity: 0.4 }} />
        </Group>
        <Group justify="space-between" wrap="nowrap" px="md" h="100%" style={{ flex: 1, minWidth: 0 }}>
          <Skeleton height={22} width={160} radius="sm" />
          <Group gap={10} wrap="nowrap">
            <Skeleton height={32} width={32} radius="xl" />
            <Skeleton height={32} width={32} radius="xl" />
          </Group>
        </Group>
      </Group>

      <Flex style={{ flex: 1, minHeight: 0 }}>
        <Box
          component="aside"
          visibleFrom="sm"
          style={{
            width: SIDEBAR_WIDTH,
            flexShrink: 0,
            backgroundColor: EXPO_HEAD_SIDEBAR_BG,
            backgroundImage: SIDEBAR_GRIDLINE_OVERLAY,
            borderRight: "1px solid rgba(255, 255, 255, 0.14)",
            display: "flex",
            flexDirection: "column",
            padding: "12px 12px 16px",
            gap: 8,
          }}
        >
          <Stack gap={8} style={{ flex: 1 }}>
            {Array.from({ length: 8 }).map((_, i) => (
              <Skeleton
                key={`expo-head-nav-${i}`}
                height={40}
                radius="md"
                style={{ opacity: 0.35 }}
              />
            ))}
          </Stack>
          <Stack gap={8} mt="auto" pt="md">
            <Skeleton height={48} radius="md" style={{ opacity: 0.4 }} />
            <Skeleton height={36} radius="md" style={{ opacity: 0.3 }} />
          </Stack>
        </Box>
        <Box style={{ flex: 1, minWidth: 0, overflow: "auto" }}>
          <ExpoHeadContentFallback />
        </Box>
      </Flex>
    </Flex>
  );
}
